import { ChangeEvent, useRef } from 'react';
import * as EditorTypeAll from '../tinymce.d';
import { Paperclip } from 'lucide-react';

interface Props {
  allowedFileTypes: string[];
  editorInstance: EditorTypeAll.Editor;
  attachment_upload_handler?: (files: FileList) => void;
}

const Attachment = ({ editorInstance, attachment_upload_handler, allowedFileTypes }: Props) => {
  const attachInputRef = useRef(null);
  const attachmentAction = () => {
    if (attachInputRef.current) {
      document.body.click();
      (attachInputRef.current as HTMLInputElement).click();
    }
  };
  console.log('allowedFileTypes', allowedFileTypes);

  const changeFile = (event: ChangeEvent<HTMLInputElement>) => {
    console.log(editorInstance);
    if (event?.target?.files && attachment_upload_handler) {
      attachment_upload_handler(event.target.files);
      event.target.value = '';
    }
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={attachmentAction}>
        {/* <img width="18px" height="18px" src={attachment} /> */}
        <Paperclip strokeWidth={1.5} size={18} />
        <input
          className="absolute left-[-9999px]"
          accept={allowedFileTypes?.join(',') || '*'}
          onChange={changeFile}
          ref={attachInputRef}
          type="file"
          multiple
        />
      </div>
    </>
  );
};

export default Attachment;
